import { motion } from "framer-motion";

export const Intro = () => (
  <section data-testid="intro-section" className="py-24 md:py-32 lg:py-40 bg-[#F5F5F7]">
    <div className="max-w-3xl mx-auto px-6 md:px-12 text-center">
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.7 }}
        className="text-xs md:text-sm tracking-[0.2em] uppercase font-semibold text-[#86868B] mb-6"
      >
        What Makes Nyla Different
      </motion.p>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.1 }}
        data-testid="intro-heading"
        className="font-display text-4xl md:text-5xl lg:text-6xl leading-tight tracking-tight font-medium text-[#1D1D1F]"
      >
        Water, the way nature intended.
      </motion.h2>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.25 }}
        className="mt-8 text-lg md:text-xl leading-relaxed text-[#86868B]"
      >
        Most water comes from the ground — pumped from wells, drawn from rivers, stripped
        from ancient aquifers. Nyla's water comes from a higher source: the atmosphere.
        Each drop begins as pure moisture in the air, untouched by soil contaminants,
        heavy metals, or industrial runoff.
      </motion.p>
      <motion.p
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.35 }}
        className="mt-6 text-lg md:text-xl leading-relaxed text-[#86868B]"
      >
        The atmosphere holds nature's most renewable reservoir — moisture that the water
        cycle replenishes every few days. By gathering it gently and enriching it with
        essential Magnesium and Calcium, we craft hydration that is kind to your body and
        kinder still to the planet: no depleted wells, no disturbed rivers, no compromise.
      </motion.p>
      <motion.blockquote
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-80px" }}
        transition={{ duration: 0.8, delay: 0.4 }}
        data-testid="intro-quote"
        className="mt-14 font-display text-2xl md:text-3xl font-medium tracking-tight text-[#2C3E35]"
      >
        “We don't take water from the earth.
        <br className="hidden md:block" /> We receive it from the sky.”
      </motion.blockquote>
    </div>
  </section>
);
